import { Typography } from '@material-ui/core';
import React from 'react';

const Label = props => <Typography {...props} />;

export default Label;
